import { createNamedOptionChoice, fetchNamedOptionChoices } from "features/settings/api/namedOptionResource";
import { hospitalResource } from "features/settings/constants/healthSelectionResources";

export const fetchHospitals = async (search: string) => {
  return fetchNamedOptionChoices(hospitalResource, search);
};

export const createHospital = async (name: string) => {
  return createNamedOptionChoice(hospitalResource, name);
};
